module.exports = __webpack_public_path__ + "img/transaction-history.652bafbe.svg";